console.log(
  "Environment Variables:",
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

export const config = {
  backendUrl:
    process.env.REACT_APP_NODE_ENV === "production"
      ? process.env.REACT_APP_BACKEND_URL ||
        "https://aicoachingbackend-production.up.railway.app"
      : process.env.REACT_APP_BACKEND_URL || "http://localhost:3000",
  frontendUrl:
    process.env.REACT_APP_NODE_ENV === "production"
      ? process.env.REACT_APP_FRONTEND_URLS ||
        "https://app.briefscoach.com"
      : process.env.REACT_APP_FRONTEND_URLS ||
        "http://app.localhost:3001",
};
